import { ScrollLink as ScrollLinkType } from '@/schemas/sceneDataSchema';
import { Link } from '@mui/material';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const ScrollLink = ({ component }: { component: ScrollLinkType }) => {
  const { trackEvent } = useAnalytics();

  const onClick = () => {
    trackEvent(`${eventName(component.text)}_SCROLL_LINK_CLICKED`);
    const element = document.getElementById(component.scroll_id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Link
      onClick={onClick}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
    >
      {component.text}
    </Link>
  );
};
